/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import {
	ThemeOptions,
	type Theme,
} from '@jira/platform__common-constants/src/theme-preference.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
// eslint-disable-next-line jira/import-whitelist
import { userPreferenceAPI } from '@jira/platform__services-user-preferences/src/utils/index.tsx';
import { THEME_PREFERENCE_KEY } from './themeColorModes.constants.tsx';

// This file contains old logic that is executed only when shared-user-preferences flag is off.
// TODO (DST): Should be deleted along with shared-user-preferences cleanup

/**
 * @deprecated Use setThemePreference instead - this function is only needed to support the existing behaviour when the shared-user-preferences feature flag is disabled.
 */
export const setThemePreference = (theme: Theme): Promise<void> => {
	const promise = userPreferenceAPI.set(THEME_PREFERENCE_KEY, theme);
	promise.catch((error) => {
		fireErrorAnalytics({
			meta: {
				id: 'ThemePreferenceCRUD',
				packageName: 'jiraRouterResourcesThemePreference',
			},
			error,
			attributes: {
				op: 'put',
				errName: String(error.name),
				statusCode: error.statusCode,
				param: `to:${theme}`,
			},
		});
	});
	return promise;
};
/**
 * @deprecated Use getThemePreference instead - this function is only needed to support the existing behaviour when the shared-user-preferences feature flag is disabled.
 * Asynchronously retrieves the user's preferred theme from a preference API and ensures its validity
 * against a set of known themes. Returns the valid theme or undefined for unrecognized themes.
 */
export const getThemePreference = async (): Promise<Theme | undefined> => {
	const promise = userPreferenceAPI.get(THEME_PREFERENCE_KEY);
	promise.catch((error) => {
		fireErrorAnalytics({
			meta: {
				id: 'ThemePreferenceCRUD',
				packageName: 'jiraRouterResourcesThemePreference',
			},
			error,
			attributes: {
				op: 'get',
				errName: String(error.name),
				statusCode: error.statusCode,
			},
		});
	});
	promise.then((theme) => {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		if (theme && !(ThemeOptions as ReadonlyArray<string>).includes(theme)) {
			// very unlikely but…
			fireErrorAnalytics({
				meta: {
					id: 'ThemePreferenceCRUD',
					packageName: 'jiraRouterResourcesThemePreference',
				},
				error: new Error('Unrecognized theme!'),
				attributes: {
					op: 'get',
					theme,
					errName: 'unrecognized value!',
				},
			});
		}
	});

	const theme = await promise;
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return theme && (ThemeOptions as ReadonlyArray<string>).includes(theme)
		? // oxlint-disable-next-line typescript/consistent-type-assertions
			(theme as Theme)
		: undefined;
};
